export { LightBulb as default } from './LightBulb';
